// Validation utilities for TuMesaYa forms
import { ValidationError, FormData } from '../types';

// Re-export types for backward compatibility
export type { ValidationError, FormData };

// Email validation
export const validateEmail = (email: string): string | null => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) return 'El email es obligatorio';
  if (!emailRegex.test(email)) return 'Formato de email inválido';
  return null;
};

// Phone validation (Spanish format)
export const validatePhone = (phone: string): string | null => {
  const phoneRegex = /^[6-9]\d{8}$/; // Spanish mobile numbers
  if (!phone) return 'El teléfono es obligatorio';
  if (phone.length < 9) return 'El teléfono debe tener al menos 9 dígitos';
  if (phone.length > 15) return 'El teléfono no puede tener más de 15 dígitos';
  if (!phoneRegex.test(phone.replace(/\s/g, ''))) {
    return 'Formato de teléfono inválido (debe ser un número español válido)';
  }
  return null;
};

// Name validation
export const validateName = (name: string): string | null => {
  if (!name) return 'El nombre es obligatorio';
  if (name.length < 2) return 'El nombre debe tener al menos 2 caracteres';
  if (name.length > 100)
    return 'El nombre no puede tener más de 100 caracteres';
  return null;
};

// Restaurant validation
export const validateRestaurant = (restaurant: string): string | null => {
  if (!restaurant) return 'El nombre del restaurante es obligatorio';
  if (restaurant.length < 2)
    return 'El nombre del restaurante debe tener al menos 2 caracteres';
  if (restaurant.length > 100)
    return 'El nombre del restaurante no puede tener más de 100 caracteres';
  return null;
};

// GDPR validation
export const validateGDPR = (gdpr: boolean): string | null => {
  if (!gdpr) return 'Debes aceptar la política de privacidad para continuar';
  return null;
};

// Complete form validation
export const validateForm = (data: FormData): ValidationError[] => {
  const errors: ValidationError[] = [];

  const nameError = validateName(data.name);
  if (nameError) errors.push({ field: 'name', message: nameError });

  const emailError = validateEmail(data.email);
  if (emailError) errors.push({ field: 'email', message: emailError });

  const phoneError = validatePhone(data.phone);
  if (phoneError) errors.push({ field: 'phone', message: phoneError });

  const restaurantError = validateRestaurant(data.restaurant);
  if (restaurantError)
    errors.push({ field: 'restaurant', message: restaurantError });

  const gdprError = validateGDPR(data.gdpr || false);
  if (gdprError) errors.push({ field: 'gdpr', message: gdprError });

  return errors;
};

// Format phone number for display
export const formatPhone = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 9) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
  }
  return phone;
};

// Clean phone number for API
export const cleanPhone = (phone: string): string => {
  return phone.replace(/\s/g, '');
};
